import axios from 'axios'

export default {
	getCompanyById (id) {
		return axios.get(`/api/company/${id}`)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
	},
	getCompanyBySearch (company) {
		return axios.get(`/api/company/`, {
			params: {
				search: company
			}
		})
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
	},
	getCompanyAll (params) {
		return axios.get(`/api/company/`, {
			params
		})
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
	}
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/company.js